<template>
  <form id="id-recipient-language-form">
    <div class="form-group">
      <v-select :value="targetDialect" :options="textDialects" placeholder="-- Autodetect Language Dialect --"
        @input="changeLanguage">
        <template #search="{ attributes, events }">
          <input class="vs__search" v-bind="attributes" v-on="events" />
        </template>
      </v-select>
    </div>
    <div class="form-action bg-light px-3 py-3 d-flex flex-row-reverse">
      <button type="button" class="btn btn-info btn-rounded" @click="updateRecipient" :disabled="httpPending">
        <i v-if="httpPending" class="fa fa-spinner fa-spin"></i>
        <span v-else>Change</span>
      </button>
    </div>
  </form>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import VSelect from "vue-select";
import { EventBus } from "../../events/eventBus";

export default {
  name: "RecipientLanguageForm",
  components: { VSelect },
  props: { language: String },
  computed: {
    ...mapGetters("user", ["currentToken", "currentUser"]),
    ...mapGetters("agency", ["textDialects", "currentAgencyId"]),
    ...mapGetters("conversations", ["currentConversation"]),
  },
  data() {
    return {
      targetDialect: null,
      httpPending: false,
      changed: false,
    };
  },
  methods: {
    changeLanguage(lang) {
      if (lang === null) {
        if (this.targetDialect !== null) {
          this.targetDialect = null;
          this.changed = true;
        }
      } else {
        if (!this.targetDialect || (this.targetDialect && lang.code !== this.targetDialect.code)) {
          this.targetDialect = lang;
          this.changed = true;
        }
      }
    },
    async updateRecipient() {
      if (this.changed) {
        this.httpPending = true;

        try {
          const recipientId = this.currentConversation.recipients[0].recipient_id;
          const recipientNumber = this.currentConversation.recipients[0].number;
          const selectedLang = this.targetDialect ? this.targetDialect.code : "";

          console.log(`selectedLang: '${selectedLang}''`);
          if (selectedLang === "") {
            const payload = {
              number: recipientNumber,
              language: this.targetDialect ? this.targetDialect.code : "",
            };
            await this.$ConveyApi.recipientsApi.updateRecipient({ numberOrId: recipientId, payload });
          } else {
            await this.$ConveyApi.recipientsApi.updateRecipientLanguage({ numberOrId: recipientId, language: selectedLang });
          }
          this.$toastr("success", "Updated Recipient Language");
          this.httpPending = false;
          EventBus.$emit("close-modal");
        } catch (e) {
          console.error(`Error updating recipient ${err}`);
          this.$toastr("error", "Error Updating Recipient Language");
          this.httpPending = false;
          return false;
        }
      }
    },
  },
  mounted() {
    this.changed = false;
    let code = this.language;
    if (!code || code === "") {
      this.targetDialect = null;
    } else {
      code = code.toLowerCase();
      this.targetDialect = this.textDialects.find(lang => lang.code === code);
    }
  },
};
</script>

<style lang="scss" scoped>
.form-action {
  margin-left: -1rem;
  margin-right: -1rem;
  margin-bottom: -1rem;
  border-radius: 0 0 5px 5px;
}
</style>